import { IAttribute } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AzurePostgreSqlTableDataset } from 'app/model/dataset/azure-postgre-sql-table.dataset';
import { TabularCopySource } from './tabular-type.copysource';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { partitionOptionConst } from 'app/registries/consts/metadata-consts';

@Metamodel.model({
    name: adfModelTypeMap.azurePostgreSQL.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(AzurePostgreSqlTableDataset) }
})
export class AzurePostgreSqlCopySource extends TabularCopySource {
    public static readonly PARTITION_OPTION: IAttribute;

    public static readonly PARTITION_NAMES: IAttribute;
    public static readonly PARTITION_COLUMN_NAME: IAttribute;
    public static readonly PARTITION_UPPER_BOUND: IAttribute;
    public static readonly PARTITION_LOWER_BOUND: IAttribute;

    public static readonly QUERY_TIMEOUT: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'QUERY_TIMEOUT',
        display: stringResources.ModelName_Source_QueryTimeout_Min,
        accepts: ['String'],
        constraint: {
            minimum: 1,
            maximum: 1440
        }
    })
    public queryTimeout?: number = 120;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_OPTION',
        display: stringResources.ModelName_Partition_Option
    })
    public partitionOption?: string = partitionOptionConst.none;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_NAMES',
        display: stringResources.ModelName_Partition_Names
    })
    public partitionNames?: string[];

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_COLUMN_NAME',
        display: stringResources.ModelName_Partition_ColumnName
    })
    public partitionColumnName?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_UPPER_BOUND',
        display: stringResources.ModelName_Partition_UpperBound
    })
    public partitionUpperBound?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_LOWER_BOUND',
        display: stringResources.ModelName_Partition_LowerBound
    })
    public partitionLowerBound?: string;
}
